<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl md:text-3xl ">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('bank_statements')">Wyciągi</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      {{ bank_statement.id }}
    </h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full lg:w-1/2">
        <form @submit.prevent="update">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-area-input class="pr-6 pb-8 w-full" v-model:checked="form.description" :error="form.errors.description" label="Opis" />
          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center" v-if="$page.props.can['edit bank statement']">
            <button v-if="!bank_statement.is_imported && $page.props.can['delete bank statement']" class="text-red-600 hover:underline mr-5" tabindex="-1" type="button" @click="destroy">Usuń wyciąg</button>
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Aktualizuj opis</loading-button>
          </div>
        </form>
      </div>
    </div>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextAreaInput from '@/ShtaxComponents/TextAreaInput'
import Swal from 'sweetalert2'

export default {
  metaInfo() {
    return { title: 'Pozycje na wyciągu: '+ this.bank_statement.id }
  },
  components: {
    Icon,
    LoadingButton,
    TextAreaInput
  },
  layout: Layout,
  props: {
    bank_statement: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        description: this.bank_statement.description
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('bank_statements.update', this.bank_statement.id))
    },
    destroy() {
      Swal.fire({
        title: 'Jesteś pewien że chcesz usunąć wybrany wyciąg?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń!',
        cancelButtonText: 'Nie'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(this.route('bank_statements.destroy', this.bank_statement.id))
        }
      })
    },
  },

}
</script>
